export function isTouchDevice() {
    return (('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0) ||
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ((navigator as any).msMaxTouchPoints > 0));
}
